import { TermsNConditions } from "../../component";

const TermsAndCondition = () => {
  return <TermsNConditions />;
}
export default TermsAndCondition;
